<template>
    <app-data-table
        :fields="fields"
        :items="data.data"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="mail_type.name" slot-scope="{ item }">
            <i class="fa" :class="item.mail_type.fa_class"></i>
            {{ item.mail_type.name }}
        </template>

        <template slot="owner.name" slot-scope="{ item }">
            {{ !!item.owner ? item.owner.name : '' }}
        </template>

        <template slot="user.name" slot-scope="{ item }">
            {{ item.user.name | elipsis(18) }}
        </template>

        <template slot="notes" slot-scope="{ item }">
            {{ item.notes | elipsis(20) }}
        </template>

        <template slot="created_at" slot-scope="{ item }">
            {{ item.created_at | datetime }}
        </template>

        <template slot="duration" slot-scope="{ item }">
            {{ item.created_at | duration }}
        </template>

        <template slot="delivery.created_at" slot-scope="{ item }">
            <span v-if="!!item.delivery">{{
                item.delivery.created_at | datetime
            }}</span>
            <span v-else></span>
        </template>

        <template slot="actions" slot-scope="{ item }">
            <b-button size="sm" variant="primary" @click="viewMail(item)"
                ><i class="fa fa-search-plus"></i
            ></b-button>
        </template>
    </app-data-table>
</template>
<script>
export default {
    data() {
        return {
            fields: [
                {
                    key: 'mail_type.name',
                    label: 'Tipo',
                    filter: true,
                },
                {
                    key: 'destination.name',
                    label: 'Destino',
                    filter: true,
                },
                {
                    key: 'owner.name',
                    label: 'Para',
                    filter: true,
                },
                {
                    key: 'user.name',
                    label: 'Recibido por',
                    filter: true,
                },
                {
                    key: 'created_at',
                    label: 'Recibido el',
                    filter: true,
                },
                {
                    key: 'notes',
                    label: 'Notas',
                    filter: true,
                },
                {
                    key: 'duration',
                    label: 'Duración',
                    filter: true,
                },
                {
                    key: 'delivery.delivered_to',
                    label: 'Entregado a',
                    filter: true,
                },
                {
                    key: 'delivery.created_at',
                    label: 'Entregado el',
                    filter: true,
                },
                {
                    key: 'actions',
                    label: 'Acciones',
                },
            ],
        }
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        viewMail: {
            type: Function,
            required: true,
        },
        onChangePage: {
            type: Function,
            required: true,
        },
    },
    methods: {
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
    },
}
</script>
